export const CASE_ACTION_COLUMN_WIDTH = '24px';

export function getCaseColumns(canViewClinicsColumn, canViewLabsColumn) {
    if (canViewClinicsColumn && canViewLabsColumn) {
        return [
            { key: 'status', label: 'Status', width: '2fr' },
            { key: 'patientName', label: 'Patient Name', width: '2fr' },
            { key: 'doctorName', label: 'Doctor Name', width: '1.9fr' },
            { key: 'clinicName', label: 'Clinic', width: '1.7fr' },
            { key: 'labName', label: 'Lab', width: '1.7fr' },
            { key: 'orderNumber', label: 'ID', width: '1.2fr' },
            { key: 'createdOn', label: 'Created', width: '1.3fr' },
            { key: 'receivedOn', label: 'Received', width: '1.3fr' },
            { key: 'dueOn', label: 'Due', width: '1.3fr' },
        ];
    }

    if (canViewClinicsColumn) {
        return [
            { key: 'status', label: 'Status', width: '2fr' },
            { key: 'patientName', label: 'Patient Name', width: '2.35fr' },
            { key: 'doctorName', label: 'Doctor Name', width: '2fr' },
            { key: 'clinicName', label: 'Clinic', width: '2.05fr' },
            { key: 'orderNumber', label: 'ID', width: '1.2fr' },
            { key: 'createdOn', label: 'Created', width: '1.3fr' },
            { key: 'receivedOn', label: 'Received', width: '1.3fr' },
            { key: 'dueOn', label: 'Due', width: '1.3fr' },
        ];
    }

    if (canViewLabsColumn) {
        return [
            { key: 'status', label: 'Status', width: '2fr' },
            { key: 'patientName', label: 'Patient Name', width: '2.35fr' },
            { key: 'doctorName', label: 'Doctor Name', width: '2fr' },
            { key: 'labName', label: 'Lab', width: '2.05fr' },
            { key: 'orderNumber', label: 'ID', width: '1.2fr' },
            { key: 'createdOn', label: 'Created', width: '1.3fr' },
            { key: 'receivedOn', label: 'Received', width: '1.3fr' },
            { key: 'dueOn', label: 'Due', width: '1.3fr' },
        ];
    }

    return [
        { key: 'status', label: 'Status', width: '2fr' },
        { key: 'patientName', label: 'Patient Name', width: '3.1fr' },
        { key: 'doctorName', label: 'Doctor Name', width: '2.4fr' },
        { key: 'orderNumber', label: 'ID', width: '1.2fr' },
        { key: 'createdOn', label: 'Created', width: '1.3fr' },
        { key: 'receivedOn', label: 'Received', width: '1.3fr' },
        { key: 'dueOn', label: 'Due', width: '1.3fr' },
    ];
}

export function getCaseGridTemplate(columns) {
    const widths = columns.map((column) => `minmax(0, ${column.width})`);
    return [...widths, CASE_ACTION_COLUMN_WIDTH].join(' ');
}
